var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('CardBox',_vm._g({staticStyle:{"padding":"15px 20px"},attrs:{"btnList":_vm.btnList}},_vm.$listeners),[_c('div',{staticClass:"video",on:{"click":function($event){return _vm.$emit('handleToDetail')}}},[_c('CardFileDetail',{attrs:{"info":_vm.info}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }